// @core/api/endpoints/secret/get_certificate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CertificateResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get certificate
 * Returns a certificate by its serial number.
 */
export async function GetCertificate(
  engine_id: string,
  serial: string,
  options?: RequestOptions
): Promise<CertificateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/cert/:serial`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':serial', encodeURIComponent(serial));
  const requestOptions = options;
  return client.get<CertificateResponse>(requestPath, { ...requestOptions });
}
